// src/components/HeroSection.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './HeroSection.css';
import logoImage from '../assets/bluedot_3200_grey - text.png';

function HeroSection() {
    const [offsetY, setOffsetY] = useState(0);

    const handleScroll = () => setOffsetY(window.pageYOffset);

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const heroStyle = {
        background: `url(${process.env.PUBLIC_URL + '/hero-bg.jpg'}) no-repeat center center/cover`,
        backgroundPositionY: offsetY * 0.5
    };

    return (
        <section className="hero" style={heroStyle}>
            <div className="hero-logo">
                <img src={logoImage} alt="BlueDot Logo" />
            </div>
            <div className="hero-content">
                <h2>Transformamos ideias em soluções digitais</h2>
                <p>Desenvolvimento de aplicativos, sistemas e automações para impulsionar o seu negócio.</p>
                <a href="#contato" className="btn">Fale Conosco</a>
            </div>
        </section>
    );
}

export default HeroSection;
